<script>
import { mapActions, mapState } from "vuex";

import orderMixin from "@/mixins/orderMixin";
import dateMixin from "@/mixins/dateMixin";
import timeMixin from "@/mixins/timeMixin";
import numberMixin from "@/mixins/numberMixin";
import addressMixin from "@/mixins/addressMixin";

import ProfileRow from "@/components/_Shared/Users/Profile/Row";
import DataTableTitle from "@/components/_Shared/DataTable/Title";
import IconTooltip from "@/components/_Shared/Users/Status/IconTooltip";

export default {
  mixins: [orderMixin, dateMixin, timeMixin, numberMixin, addressMixin],

  components: {
    ProfileRow,
    DataTableTitle,
    IconTooltip
  },

  props: {
    user: {
      type: [Object, Boolean],
      required: false,
      default: false
    }
  },

  data() {
    return {
      copyOptions: {
        icon: "file_copy",
        color: "grey",
        description: "Clique aqui para copiar o link de checkout."
      },
      cycleOptions: {
        icon: "add_shopping_cart",
        color: "accent",
        description: "Faz parte de uma assinatura."
      },
      orderOptions: {
        icon: "shopping_cart",
        color: "primary",
        description: "É um pedido avulso."
      }
    };
  },

  computed: {
    ...mapState("ordersList", [
      "headers",
      "items",
      "totalItems",
      "options",
      "search",
      "loader",
      "footerProps"
    ]),
    options: {
      get() {
        return this.$store.state.ordersList.options;
      },
      set(value) {
        this.$store.dispatch("ordersList/setOptions", value);
      }
    }
  },

  methods: {
    ...mapActions("ordersList", ["getItems", "setSearch", "setUser"]),

    copied() {
      this.$toast.success("Link copiado com sucesso!", {
        icon: "check_circle"
      });
    },

    copyLink(item) {
      return item.cycle
        ? `https://cliente.donamaid.com/checkout/assinaturas/${item.cycle.id}`
        : `https://cliente.donamaid.com/checkout/${item.id}`;
    },

    submitSearch(text) {
      try {
        this.setSearch(text);
      } catch (e) {
        this.$toast.error(e);
      }
    },

    orderLink(id) {
      return { name: "order", params: { id } };
    }
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true
    }
  },

  mounted() {
    this.setUser(this.user);
  }
};
</script>

<template>
  <v-card class="mb-20 px-4" flat>
    <data-table-title
      icon="bookmark"
      title="Pedidos"
      button-text="Criar novo pedido"
      :button-route="{ name: 'new-order' }"
      :search="search"
      @search="submitSearch($event)"
    />

    <v-divider></v-divider>

    <v-layout column>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="footerProps"
        :loading="loader"
      >
        <template v-slot:item.status="{ item }">
          <router-link :to="orderLink(item.id)">
            <icon-tooltip :options="getStatus(item.status)" />
          </router-link>
        </template>

        <template v-slot:item.link="{ item }">
          <div
            class="pointer"
            v-clipboard:copy="copyLink(item)"
            v-clipboard:success="copied"
          >
            <icon-tooltip :options="copyOptions" />
          </div>
        </template>

        <template v-slot:item.type="{ item }">
          <icon-tooltip :options="item.cycle ? cycleOptions : orderOptions" />
        </template>

        <template v-slot:item.created_at="{ item }">
          <v-chip small outlined>{{ item.created_at | dateAndTime }}</v-chip>
        </template>

        <template v-slot:item.customer="{ item }">
          <profile-row :account="item.customer.account" />
        </template>

        <template v-slot:item.professional="{ item }">
          <profile-row :account="item.professional.account" />
        </template>

        <template v-slot:item.starts_at="{ item }">
          <v-chip small outlined>{{
            item.schedule_event.starts_at | dateAndTime
          }}</v-chip>
        </template>
        <template v-slot:item.duration="{ item }">
          <v-chip small outlined>{{
            item.schedule_event.duration | secondsToHours
          }}</v-chip>
        </template>
        <template v-slot:item.city="{ item }">
          <v-chip small color="primary">{{
            item.address | cityAndState
          }}</v-chip>
        </template>
        <template v-slot:item.price="{ item }">
          <v-chip small>{{ item.amount.price | intToCurrency }}</v-chip>
        </template>
        <template v-slot:item.fee="{ item }">
          <v-chip small color="accent">{{
            item.amount.fee | intToCurrency
          }}</v-chip>
        </template>
        <template v-slot:item.total="{ item }">
          <v-chip small>{{ item.amount.total | intToCurrency }}</v-chip>
        </template>
      </v-data-table>
    </v-layout>
  </v-card>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Orders/List.vue